export default "__VITE_ASSET__DEsUwTyC__"